import React from "react";

type CardLayoutProps = {
  children: React.ReactNode;
  containerClassName?: string;
  className?: string;
  id?: string;
};

const CardLayout = ({
  children,
  containerClassName = "",
  className = "",
  id,
}: CardLayoutProps) => {
  return (
    <div className={`mt-6 ${containerClassName}`} id={id}>
      <div
        className={`flex flex-col gap-4 rounded-lg border bg-white p-4 ${className}`}
      >
        {children}
      </div>
    </div>
  );
};

export default CardLayout;
